var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "issueListWrap",
    class: {
      active: _vm.status.issueListViewBln
    }
  }, [_vm.processDetail.processType == 'NORMAL' ? _c('div', {
    staticClass: "topInfo"
  }, [_c('div', {
    staticClass: "btn_area"
  }, [_c('div', {
    staticClass: "btn_area_left"
  }, [_c('span', {
    staticClass: "protocolCnt"
  }, [_vm._v("기본값SET (" + _vm._s(_vm.filteredExperimentList.length) + "개)")])]), _c('div', {
    staticClass: "btn_area_right"
  }, [_vm.experimentFlag && _vm.getExperimentResultMode == 'edit' ? _c('button', {
    on: {
      "click": _vm.callExperimentType
    }
  }, [_vm._v("기본값SET 복사")]) : _vm._e()]), _c('span', {
    staticStyle: {
      "text-align": "center",
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*ROW 추가 시 사용하는 기본값들의 집합")])])]) : _vm._e(), _c('List', {
    attrs: {
      "experimentList": _vm.filteredExperimentList,
      "experimentFlag": _vm.experimentFlag
    }
  }), _c('BtmComp'), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }